module.exports = __webpack_public_path__ + "img/dcpower.02bdc7a5.png";